<template>
  <q-page padding>
    <div class="row justify-between">
      <div
        class="row text-weight-bold"
        style="text-decoration: underline; font-size: 20px"
      >
        <img :src="logoUrl" class="logo q-mr-md" />
        <div class="column align-center text-weight-bold">
          <span>Num Pedido</span>
          <span>{{ dados.id }}</span>
        </div>
      </div>
      <span
        class="text-white bg-red row justify-center q-pl-md q-pr-md"
        style="font-size: 24px; border-radius: 30px"
        >Solicitação de Compra de Material</span
      >
      <div
        class="column align-center text-weight-bold"
        style="text-decoration: underline; font-size: 20px"
      >
        <span>Data do Pedido</span>
        <span v-if="dados.created_at">{{
          dados.created_at.split(" ")[0].split("-").reverse().join("/")
        }}</span>
      </div>
    </div>

    <div class="row bg-grey justify-between q-pa-md header-solicitante">
      <div class="info-field">
        <span class="text-weight-bold">Solicitante:</span>
        <span class="q-ml-sm" v-if="dados && dados.products.length != 0">{{
          dados?.products?.[0]?.necessidade_compra?.solicitante?.nome || ""
        }}</span>
      </div>
      <div class="info-field">
        <span class="text-weight-bold">SC:</span>
        <span class="q-ml-sm" v-if="dados && dados.products.length != 0">{{
          dados?.products[0]?.necessidade_compra?.numero
        }}</span>
      </div>
      <div class="info-field">
        <span class="text-weight-bold">Comprador:</span>
        <span class="q-ml-sm" v-if="dados && dados.products.length != 0">{{
          dados?.products[0]?.responsavel_compra?.nome
        }}</span>
      </div>
    </div>

    <section class="row q-mt-md q-mb-md info-section">
      <div class="column info-box">
        <span class="text-weight-bold info-label">Dados Acciona:</span>
        <span class="info-text">ACCIONA CONSTRUCCION S.A.</span>
        <span class="info-text">Rua Olimpíadas, nº 134,</span>
        <span class="info-text">Conjunto 71 7° andar, Vila Olímpia</span>
        <span class="info-text">CEP: 04.551-000 - São Paulo/SP</span>
        <span class="info-text">CNPJ nº 03.503.152/0014-10</span>
      </div>
      <div class="column info-box info-box-small">
        <span class="text-weight-bold info-label">Cod Fornecedor:</span>
        <span class="info-text">{{ dados.provider_id }}</span>
        <span class="text-weight-bold info-label q-mt-md">Num Contrato:</span>
        <span class="info-text">{{
          dados.contract?.number || dados.contract?.contractNumber || ""
        }}</span>
      </div>
      <div class="column info-box" v-if="dados.provider">
        <span class="text-weight-bold info-label">FORNECEDOR:</span>
        <span class="info-text">{{ dados.provider.business_name }}</span>
        <span class="info-text" v-if="dados.provider.endereco">{{ dados.provider.endereco }}</span>
        <span class="info-text" v-if="dados.provider.cidade || dados.provider.uf">{{ dados.provider.cidade }}<span v-if="dados.provider.cidade && dados.provider.uf">/</span>{{ dados.provider.uf }}</span>
        <span class="info-text" v-if="dados.provider.cep">CEP {{ dados.provider.cep }}</span>
        <span class="info-text">{{ dados.provider.cnpj }}</span>
      </div>
      <div class="column info-box info-box-small">
        <span class="text-weight-bold info-label">Classificação Solicitação:</span>
        <span class="info-text" v-if="dados.tag">{{ dados.tag.nome.toUpperCase() }}</span>
      </div>
    </section>

    <section style="height: 60px" class="row align bg-grey">
      <div class="column">
        <span class="text-weight-bold q-ml-sm">Entregar em:</span>
        <span class="q-ml-sm"
          >R. Prof. Luís Sanches, 110 - Parque Monteiro Soares São Paulo - SP,
          02736-080</span
        >
      </div>
    </section>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <table style="width: 100%" border="1">
            <thead>
              <tr role="row">
                <th>Codigo</th>
                <th>Unid. Controle</th>
                <th>NCM</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>UND</th>
                <th>Valr. Unit.</th>
                <th>Valr. Total</th>
                <th>Previsão de Entrega Atualizada</th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr
                class="border"
                v-for="(produto, index) in produtosOrdenados"
                :key="index"
                role="row"
              >
                <td class="center">{{ produto.code }}</td>
                <td v-if="dados && dados.products.length != 0" class="center">
                  {{ produto?.necessidade_compra?.centro_custo?.codigo }} -
                  {{ produto?.necessidade_compra?.centro_custo?.nome }}
                </td>
                <td class="center" v-if="dados && dados.products.length != 0">
                  {{ produto.ncm }}
                </td>
                <td class="center">{{ produto.name }}</td>
                <td class="center">{{ formatQuantidade(produto.pivot?.amount) }}</td>
                <td class="center">
                  {{ produto.stock?.[0]?.pivot?.measurement_unit }}
                </td>
                <td class="center">
                  {{ formatPreco(produto.pivot?.price) }}
                </td>
                <td class="center">
                  {{
                    formatPreco(
                      (produto.pivot?.price || 0) * (produto.pivot?.amount || 0)
                    )
                  }}
                </td>
                <td class="center">
                  {{ formatDate(produto.pivot?.previsao_atualizada_entrega) }}
                </td>
              </tr>

              <tr>
                <td colspan="8" class="text-right">
                  <strong>Valor Total da Ordem:</strong>
                </td>
                <td class="text-center">
                  <strong>{{ formatPreco(valorTotalOrdem) }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <section style="height: 30px" class="row justify-center align bg-red">
      <span class="text-weight-bold q-ml-sm text-white">INFOS ADICIONAIS</span>
    </section>

    <q-input
      outlined
      dense
      v-model="observacao"
      placeholder="Digite sua observação"
    >
    </q-input>

    <section style="height: 30px" class="row justify-center align bg-positive">
      <span class="text-weight-bold q-ml-sm text-white"
        >Todas as notas fiscais deverão ser enviadas ao e-mail:
        finanaceiro.linha6@acciona.com.br</span
      >
    </section>

    <section style="height: 30px" class="row justify-center align bg-primary">
      <span class="text-weight-bold q-ml-sm text-white"
        >PRAZOS PARA ENTREGA DE MATERIAL</span
      >
    </section>

    <section class="column">
      <span class="text-positive">Classificação NORMAL - ATÉ 4 DIAS</span>
      <span class="text-blue">Classificação URGENTE - ATÉ 2 DIAS</span>
      <span class="text-red">Classificação MAQUINA PARADA - ATÉ 1 DIA</span>
    </section>
  </q-page>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";

// função para formatar quantidade (minimo 2 casas decimais, maximo 4)
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,00";
  const num = Number(value);
  if (isNaN(num)) return "0,00";

  let formatted = num.toFixed(4);

  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return formatted.replace('.', ',');
};

// funçao para formatar preço (R$ com minimo 2 casas decimais, maximo 4)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(value);
  if (isNaN(num)) return "R$ 0,00";

  let formatted = num.toFixed(4);
  
  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return `R$ ${formatted.replace('.', ',')}`;
};

const formatDate = (dateString) => {
  if (!dateString) return "-";

  if (dateString.includes('-')) {
    const datePart = dateString.split(' ')[0];
    const parts = datePart.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  }
  
  return dateString;
};

export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const $q = useQuasar();
    const produtos = ref([]);
    const id = route.params.id;
    const observacao = ref("");

    const logoUrl = store.state.autenticacao.logo.logo; // Substituir por chamada real da unidade
    const dados = ref("");

    const getDados = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        const response = await store.dispatch("compras/pedidoEspecifico", {
          id: id,
        });

        dados.value = response.data.message;
        observacao.value = response.data.message.observacao;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const adicionarObservacao = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        await store.dispatch("compras/adicionarObservacao", {
          purchase_id: id,
          observacao: observacao.value,
          vendor_id: store.state.org.unidadeData.id,
          provider_id: dados.value.provider.id,
        });

        $q.notify({
          message: "Observação alterada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const valorTotalOrdem = computed(() => {
      if (!dados.value || !dados.value.products) return 0;
      return dados.value.products.reduce((total, produto) => {
        return (
          total + (produto.pivot?.price || 0) * (produto.pivot?.amount || 0)
        );
      }, 0);
    });

    const produtosOrdenados = computed(() => {
      if (!dados.value || !dados.value.products) return [];
      
      return [...dados.value.products].sort((a, b) => {
        const nomeA = (a.name || '').toLowerCase();
        const nomeB = (b.name || '').toLowerCase();
        return nomeA.localeCompare(nomeB, 'pt-BR');
      });
    });

    watchDebounced(
      () => observacao.value,
      () => {
        if (observacao.value == dados.value.observacao) return;
        adicionarObservacao();
      },
      { debounce: 1000 }
    );

    return {
      dados,
      getDados,
      produtos,
      observacao,
      formatPreco,
      formatQuantidade,
      formatDate,
      valorTotalOrdem,
      produtosOrdenados,
      logoUrl,
    };
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}

.align {
  align-items: flex-start;
}

.align-center {
  align-items: center;
}

.justify-center {
  height: 46px;
  align-items: center;
}

.logo {
  width: 100px;
  object-fit: contain;
}

.table {
  display: table;
  border-collapse: separate;
  border-spacing: 5px;
}

.cell {
  display: table-cell;
  padding: 5px;
  border: 1px solid black;
}

.largura {
  width: 170px;
}

.left {
  margin-left: 12px;
}

.header-solicitante {
  font-size: 28px;
  min-height: 50px;
  align-items: center;
}

.header-solicitante .info-field {
  font-size: 28px;
}

.info-section {
  gap: 10px;
  border: 1px solid #ccc;
  padding: 10px;
}

.info-box {
  flex: 1;
  min-width: 200px;
  gap: 2px;
}

.info-box-small {
  flex: 0.5;
  min-width: 150px;
}

.info-label {
  font-size: 12px;
  margin-bottom: 3px;
}

.info-text {
  font-size: 11px;
  line-height: 1.4;
}

@page {
  size: A4 portrait;
  margin: 3mm;
}

@media print {
  * {
    box-shadow: none !important;
    text-shadow: none !important;
  }

  section,
  div,
  span,
  th,
  td {
    font-size: 12px !important;
    line-height: 1.3;
  }

  .q-page {
    padding: 0 !important;
    margin: 0 !important;
  }

  .minimo {
    font-size: 10px !important;
  }

  .font {
    font-size: 13px !important;
  }

  .detele {
    display: none !important;
  }

  .largura {
    width: 160px !important;
  }

  .left {
    margin-left: 10px !important;
  }

  .header-solicitante {
    font-size: 16px !important;
    min-height: 40px !important;
  }

  .header-solicitante .info-field {
    font-size: 16px !important;
  }

  .header-solicitante .info-field span {
    font-size: 16px !important;
  }

  .header-solicitante .text-weight-bold {
    font-size: 16px !important;
  }

  .info-section {
    gap: 8px !important;
    border: 1px solid #000 !important;
    padding: 8px !important;
    page-break-inside: avoid !important;
  }

  .info-box {
    gap: 1px !important;
  }

  .info-label {
    font-size: 11px !important;
    font-weight: bold !important;
  }

  .info-text {
    font-size: 10px !important;
    line-height: 1.3 !important;
  }

  .row {
    display: flex !important;
    flex-wrap: wrap !important;
    page-break-inside: avoid !important;
  }

  .column {
    display: flex;
    flex-direction: column;
    page-break-inside: avoid !important;
  }

  table {
    page-break-inside: auto;
    border-collapse: collapse;
    width: 100%;
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  thead {
    display: table-header-group;
    background-color: #f0f0f0 !important;
  }

  th,
  td {
    padding: 4px;
    border: 1px solid black;
    font-size: 11px;
    text-align: center;
    vertical-align: middle;
  }

  .bg-red {
    background-color: #e53935 !important;
    color: white !important;
  }

  .bg-grey {
    background-color: #9e9e9e !important;
    color: white !important;
  }

  .bg-primary {
    background-color: #1976d2 !important;
    color: white !important;
  }

  .bg-positive {
    background-color: #43a047 !important;
    color: white !important;
  }

  .text-red {
    color: #e53935 !important;
  }

  .text-blue {
    color: #1976d2 !important;
  }

  .text-positive {
    color: #43a047 !important;
  }

  .text-weight-bold {
    font-weight: bold;
  }

  .q-ml-sm,
  .q-ml-lg,
  .q-pa-sm,
  .q-pl-md,
  .q-pr-md,
  .q-mt-sm,
  .q-mb-sm,
  .q-pt-sm {
    margin: 0 !important;
    padding: 0 !important;
  }

  .text-right {
    text-align: right !important;
  }

  .text-center {
    text-align: center !important;
  }

  input,
  .q-input {
    display: none !important;
  }
}
</style>
